export default __webpack_public_path__ + "static/media/no-prospect-email.3efcd4ff.svg";